<template>
  <div>
    <div class="card shadow">
      <a id="button"></a>
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $t('message.Editligne') }}
          </h3>
        </div>
      </div>

      <div class="card-body">
          <b-form  @reset="onReset" v-if="show">
              <b-col sm="12">
                <span  class="obligatoire">*</span>

                <b-form-group
                    id="singleMotif-group"
                    :label="$tc('message.reasons', 2)"
                    label-for="singleMotif"
                >
                  <select id="singleMotif" v-model="$v.form.motif_consultation_id.$model" multiple
                          class="form-control is-invalid retirerBordure"
                          @change="clearErrorField('motif_consultation_id')"
                          required
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mReasons" :key="item.value" :value="item.value">
                      {{ item.text }}
                    </option>
                  </select>
                  <b-form-invalid-feedback v-if="$v.form.motif_consultation_id.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                  <span v-if="errorshasField('motif_consultation_id')" style="color:red">
                                    {{getErrorsField('motif_consultation_id')}}
                                    </span>
                </b-form-group>
                </b-col>
                <b-col sm="12">
                    <span  class="obligatoire">*</span>
                    <b-form-group 
                        id="consultation-group"
                        :label="$t('message.consultationDate')"
                        label-for="consultation"
                        description="">
                    <b-form-input
                        id="consultation"
                        v-model="$v.form.date_consultation.$model"
                        :state="$v.form.date_consultation.$dirty ? !(errorshasField('date_consultation') || $v.form.date_consultation.$error) : null"
                        type="date"
                        required
                        @focus="clearErrorField('date_consultation')"
                    ></b-form-input>

                    <b-form-invalid-feedback v-if="!$v.form.date_consultation.required">
                        {{ $t('message.requiredField') }}
                    </b-form-invalid-feedback>

                    <b-form-invalid-feedback v-else-if="errorshasField('date_consultation')">
                        {{ getErrorsField('date_consultation') }}
                    </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <div>
                        <b-form-checkbox
                        id="etat"
                        v-model="$v.form.etat.$model"
                        name="etat"
                        value="1"
                        unchecked-value="0"
                        >
                        Status de la ligne de temps
                        </b-form-checkbox>
                        <div> Status: <strong>{{ etat }}</strong></div>
                    </div>
                        <b-form-invalid-feedback v-if="!$v.form.etat.required">
                        {{ $t('message.requiredField') }}
                    </b-form-invalid-feedback>
                </b-col>
                <b-row class="justify-content-sm-center">
                    <b-button @click="onSubmit" variant="primary" v-if="can">
                         {{ $t('message.edit') }}
                    </b-button>
                </b-row>
          </b-form>    
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required,minLength } from 'vuelidate/lib/validators';
import _ from 'lodash';
import SlimSelect from 'slim-select';
import moment from 'moment';
import $ from 'jquery';
import Editor from '@tinymce/tinymce-vue';
import AppConfig from "../../constants/AppConfig";

export default {
  name: "AddTimeline",

  components: {
    editor: Editor
  },

  computed: {
    ...mapGetters([
      "practitioners",
      "controlDoctors",
      "reasons",
      "allergies",
      "institutions",
      "userInstitutions",
      "errors",
      'hasAdminRole',
      'hasMedecinControleRole',
      'hasPraticienRole']),

    mMedicalFile: function () {
        return (_.isUndefined(this.file) || _.isNull(this.file)) ? [] : this.file;
    },
    isFemale: function () {
        return this.mMedicalFile.hasOwnProperty('patient') ? this.mMedicalFile.patient.sexe == "F" : false;
    },

    mMedicalFile: function () {
        return _.isUndefined(this.file) ? [] : this.file;
    },
    nom: function () {
        if (!_.isUndefined(this.mMedicalFile.patient)) {
            if (!_.isUndefined(this.mMedicalFile.patient.user)) {
                let prenom = (this.mMedicalFile.patient.user.prenom == null) ? '' : this.mMedicalFile.patient.user.prenom;
                return (this.mMedicalFile.patient.user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
            }
            return "";
        }
        return '';
    },

    mReasons: function () {
      let rArray = [];

      if (!_.isUndefined(this.reasons)) {
        _.forEach(this.reasons, function (reason) {
          rArray.push({text: reason.description, value: reason.id})
        })
        return rArray;
      }
      return rArray;
    },

    can: function () {
      if (this.hasAdminRole) {
        return true;
      } else {
        return this.hasMedecinControleRole || this.hasPraticienRole;
      }
    },

    today: function () {
      return moment((new Date())).format('YYYY-MM-DD');
    },


    mContributors:function () {
      let cArray = [];
      return cArray.concat(this.mDoctors,this.mPractitioners);
    }
  },

  data() {
    return {
        etat: false,
      tinyKey: AppConfig.tinyMceKey,
      plugins: [
        'advlist autolink lists  image charmap',
        'searchreplace visualblocks code fullscreen',
        'print preview anchor insertdatetime media',
        'paste code help wordcount table'
      ],
      toolbar: 'undo redo | formatselect | bold italic | \
                           alignleft aligncenter alignright | \
                           bullist numlist outdent indent | help',
      afficherAllergie: false,
      file_id: this.$route.params.file,
      afficherAntecedent: false,
      hasChild: false,
      smoke: false,
      drink: false,
      watch: {
        etat: function (oldValue, newValue) {
          if (newValue == false) {
            this.form.etat = "0";
          }
        },

      },
      allergiesColumns: [
        {
          label: 'Description',
          field: 'description',
        },
        // {
        //     label: this.$i18n.t('message.startDate'),
        //     field: 'date',
        //     type: 'date',
        //     dateInputFormat: 'yyyy-MM-dd',
        //     dateOutputFormat: 'dd/MM/yyyy',
        // },
      ],

      antecedentsColumns: [
        {
          label: this.$i18n.tc('message.types', 1),
          field: 'type',

        },
        {
          label: 'Description',
          field: 'description',
          html:true
        },
        {
          label: this.$i18n.t('message.startDate'),
          field: 'date',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'dd/MM/yyyy',
        },
      ],

      paginationOptions: {
        enabled: true,
        mode: 'records',
        perPageDropdown: [3, 6, 10]
      },

      enabled: {enabled: true},

      sort: {
        enabled: true,
        initialSortBy: {field: 'date', type: 'desc'}
      },

      form: {
        etat: '',
        motif_consultation_id: [0],
        date_consultation: this.today,
      },


      show: true,
    }
  },

  methods: {
      getTimelines: function() {
      let args = {};
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
      };

      this.$store.dispatch('getTimelines', { args, errorMessages });
    },
    pathTo(element) {
      if (this.$route.fullPath.includes('#')) {
        let position = this.$route.fullPath.search('#');
        return this.$route.fullPath.substr(0, position) + element;
      }
      return this.$route.fullPath + element;
    },

    getReasons() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getReasons', {args: args});
    },
    getMedicalFile() {
        let args = {
            file: this.file_id
        };

        this.$store.dispatch("getMedicalFile", {
            args
        });
    },
    getMedicalValue(item) {
        return this.mMedicalFile.hasOwnProperty(item) ? this.mMedicalFile[item] : "";
    },


    onSubmit: function (evt) {
      evt.preventDefault();

      if (!_.isNull(this.form.dateRdv)){
        this.form.dateRdv = moment(this.form.dateRdv).format('YYYY-MM-DD HH:mm');
      }
      if (!this.$v.form.$invalid) {
        let formData = new FormData();

        formData.append('date_consultation', this.form.date_consultation);
        formData.append('motif_consultation_id', this.form.motif_consultation_id);
        formData.append('etat', this.form.etat);
        formData.append('dossier_medical_id', this.file_id);
        // let self= this;
        // console.log('date_consultation', this.form.date_consultation);
        // console.log('motif_consultation_id', this.form.motif_consultation_id);
        // console.log('etat', this.form.etat);
        // console.log('dossier_medical_id', this.file_id);
        // console.log('dossier_medical_id', this.file.id);
        let successMessage = this.$i18n.t('message.TimelineCreated');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };
        this.$store.dispatch('createTimeline', {args: formData, errorMessages, successMessage})
      } else {
        $('html, body').animate({scrollTop: 0}, '300');
      }
    },

    onReset: function (evt) {
      evt.preventDefault();

      // Reset our form values
      this.form.dossier_medical_id = '';
      this.form.motif_consultation_id = [''];
      this.date_consultation = '';

      // Trick to reset/clear native browser form validation state
      this.show = false;

      this.$nextTick(() => {
        this.show = true;
      });
    },

    getErrorsField(field) {
      if (this.errorshasField(field)) {
        return this.errors[field][0];
      } else {
        return '';
      }
    },
    getDoctors() {
        let args = {
            offset: this.offset,
            limit: this.limit
        };

        this.$store.dispatch('getControlDoctors', {
            args: args
        });
    },
    getListOfMedicalAdvices() {
        if (!this.hasPatientRole && !this.hasSouscripteurRole && this.can) {
            this.$store.dispatch('getMedicalAdvices', {
                args: {}
            });
        }
    },

    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field) {
      this.$store.dispatch('clearErrorField', {field});

      this.getErrorsField(field);
    }
  },

  validations: {
    form: {
      motif_consultation_id: {
        required
      },
      date_consultation: {
        required
      },
      etat:{},
    },


  },

  mounted() {
      localStorage.setItem('reload', 0);
    // Fetch reason list
    this.getReasons();
    // this.getMedicalFile();
    this.getListOfMedicalAdvices();

    this.$v.form.date_consultation.$model = this.today;

    new SlimSelect({
      select: '#singleMotif',
      placeholder: 'Select motifs',
      limit: 5
    });

    var btn = $('#button');

    $(window).scroll(function () {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });

    btn.on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({scrollTop: 0}, '300');
    });

  }
}
</script>

<style scoped>
</style>